import { SITES_URL, UPLOAD_URL } from "../constants";
import { apiSlice } from "./apiSlice";



export const sitesApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSites: builder.query({
            query: () => ({
                url: SITES_URL,
            }),
            keepUnusedDataFor:5
        }),
        getSiteDetails: builder.query({
            query: (siteId) => ({
                url: `${SITES_URL}/${siteId}`,
            }),
            keepUnusedDataFor:5
        }),
        uploadSiteFile: builder.mutation({
            query: (data) => ({
                url: `${UPLOAD_URL}`,
                method: 'POST',
                body: data,
            })
        }),
        deleteSiteFile: builder.mutation({
            query: (data) => ({
                url: `${SITES_URL}/files`,
                method: 'POST',
                body: data
            }),
        }),
        updateSite: builder.mutation({
            query: (data) => ({
                url: `${SITES_URL}/${data._id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags:['Sites']
        }),
        siteSearch: builder.mutation({
            query: (data) => ({
                url: `${SITES_URL}/siteSearch`,
                method: 'POST',
                body: data
            }),
        }),
        getLumuIncidents: builder.mutation({
            query: (data) => ({
                url: `${SITES_URL}/exapi/lumu`,
                method: 'POST',
                body: data
            }),
        }),
        dattoAuth: builder.mutation({
            query: (data) => ({
                url: `${SITES_URL}/exapi/dattoAuth`,
                method: 'POST',
                body: data
            }),
        }),
        dattoAlerts: builder.mutation({
            query: (data) => ({
                url: `${SITES_URL}/exapi/dattoAlerts`,
                method: 'POST',
                body: data
            }),
        }),
        getAirwaveInfo: builder.query({
            query: () => ({
                url: `${SITES_URL}/exapi/airwave`,
            }),
            keepUnusedDataFor:5
        }),
        getGraylogErrors: builder.query({
            query: () => ({
                url: `${SITES_URL}/exapi/graylog`,
            }),
            keepUnusedDataFor:5
        }),
        scanSiteNetwork: builder.mutation({
            query: ({ id, target, scanType }) => ({
                url: `${SITES_URL}/${id}/scan`,
                method: 'POST',
                body: { target, scanType }
            })
        }),
        stopSiteNetworkScan: builder.mutation({
            query: (id) => ({
                url: `${SITES_URL}/${id}/scan/stop`,
                method: 'POST',
            })
        }),
        scanNetwork: builder.mutation({
            query: ({ target }) => ({
                url: `${SITES_URL}/network-scan`,
                method: 'POST',
                body: { target }
            })
        }),
        stopNetwork: builder.mutation({
            query: () => ({
                url: `${SITES_URL}/network-scan/stop`,
                method: 'POST',
            })
        })
    })
});

export const {useGetSitesQuery, useGetSiteDetailsQuery, useUploadSiteFileMutation, useUpdateSiteMutation, useDeleteSiteFileMutation, useSiteSearchMutation, useGetLumuIncidentsMutation, useGetAirwaveInfoQuery, useGetGraylogErrorsQuery, useDattoAuthMutation, useDattoAlertsMutation, useScanSiteNetworkMutation, useStopSiteNetworkScanMutation, useScanNetworkMutation, useStopNetworkMutation} = sitesApiSlice;